(function() {
  let isShowPopup = false;
  let current;
  let popup;

  function throttle(mainFunction, delay) {
    let timerFlag = null; // Variable to keep track of the timer
  
    // Returning a throttled version 
    return (...args) => {
      if (timerFlag === null) { // If there is no timer currently running
        mainFunction(...args); // Execute the main function 
        timerFlag = setTimeout(() => { // Set a timer to clear the timerFlag after the specified delay
          timerFlag = null; // Clear the timerFlag to allow the main function to be executed again
        }, delay);
      }
    };
  }
  
  function setupEvents() {
    $("#VideoReels video").on("play", function() {
      $(this).parent(".video__player").addClass("playing");
      current = this;
    });
  
    $("#VideoReels video").on("pause", function() {
      $(this).parent(".video__player").removeClass("playing");
      this.currentTime = 0;
      current = null;
      
      const $time = $(this).parent(".video__player").find(".video-current-time");
      $time.css("width", "0%");
    });
  
    $("#VideoReels video").on("timeupdate", function() {
      const time = this.currentTime;
      const duration = this.duration;
      const percent = Math.floor((time / duration) * 100);
  
      $(this).parent(".video__player").find(".video-current-time").css("width", `${percent}%`);
    });

    $("#VideoReels .video-reels__carousel .video__player").on("click", function() {
      if (current && !current.paused) {
        current.pause();
      }
  
      if (popup.selectedScrollSnap() != this.dataset.index) {
        popup.scrollTo(this.dataset.index, true);
      }
      
      const video = popup.slideNodes()[this.dataset.index].querySelector("video");
      video.play();
      
      isShowPopup = true;
      document.body.style.overflow = "hidden";
      $(".video-reels__popup").css("display", "block");
    });

    $("#VideoReels .video-reels__carousel .video__product-link").on("click", function(e) {
      e.stopPropagation();
    });
    
    $("#VideoReels .video-reels__carousel .video__player").on("mouseenter touchstart", function() {
      const video = this.querySelector("video");
  
      if (!video || !video.paused) return;

      if (current && current == video) return;
  
      if (current && video != current) {
        current.pause();
      }
  
      video.play();
  
      $(this).one("mouseleave", () => {
        video.pause();
      });
    });
  
    $(window).on("touchstart", function(e) {
      if (!$(e.target).is('.video__player') && !$(e.target).is("video") && current && !current.paused && !isShowPopup) {
          current.pause();
      }
    });

    $("#VideoReels .video-reels__popup .video__player").on("click", function() {
      const video = this.querySelector("video");
  
      if (!video.paused) {
        video.pause();
      } else {
        video.play();
      }
    });

    $("#VideoReels .video__overlay .show-product").on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();

      $(this).siblings(".product__popup").addClass("show-popup");
      $(this).parent(".video__overlay").addClass("show-popup");
    });

    $("#VideoReels .video__overlay .volume-button").on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();

      if ($(this).hasClass('muted')) {
        $("#VideoReels .video-reels__popup video").each((index, video) => {
          video.muted = false;
        });
        $("#VideoReels .video-reels__popup .volume-button").removeClass('muted');
      } else {
        $("#VideoReels .video-reels__popup video").each((index, video) => {
          video.muted = true;
        });
        $("#VideoReels .video-reels__popup .volume-button").addClass('muted')
      }
    });

    // $("#VideoReels .popup__content").on("click", function(e) {
    //   e.preventDefault();
    //   e.stopPropagation();
    // })

    $("#VideoReels .video__overlay .share-button").on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();

      $(this).closest(".video__overlay").find(".share__popup").addClass("show-popup");
      $(this).closest(".video__overlay").addClass("show-popup");
    });

    $("#VideoReels .video__overlay .share-option.copy").on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();

      navigator.clipboard.writeText($(this).data("href"));

      showSnackBar("Copied!", "success");
    });

    $("#VideoReels .video__overlay .cancel-popup").on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();

      $(this).parent(".product__popup").removeClass("show-popup");
      $(this).parent(".share__popup").removeClass("show-popup");
      $(this).closest(".video__overlay").removeClass("show-popup");
    });
  }

  function setupCarousel() {
    const containerNode = document.querySelector('#VideoReels .video-reels__container');
    const carouselNode = containerNode.querySelector('.video-reels__carousel');
  
    const prevNode = containerNode.querySelector('#VideoReels .video__prev');
    const nextNode = containerNode.querySelector('#VideoReels .video__next');
    
    const options = { 
      dragFree: true,
      loop: true,
      slidesToScroll: 1,
      breakpoints: {
        '(min-width: 744px)': {
          slidesToScroll: 2,
        },
        '(min-width: 1024px)': {
          slidesToScroll: 3,
        }
      }
    };
    
    const embla = EmblaCarousel(carouselNode, options);
    
    prevNode.addEventListener('click', embla.scrollPrev, false);
    nextNode.addEventListener('click', embla.scrollNext, false);
  }

  function setupPopupCarousel() {
    const emblaNode = document.querySelector('.video-reels__popup .embla__carousel');
    const viewportNode = emblaNode.querySelector('.embla__viewport');
  
    const prevButtonNode = document.querySelector('.video-reels__popup .video__prev');
    const nextButtonNode = document.querySelector('.video-reels__popup .video__next');
    const closeButtonNode = document.querySelector('.video-reels__popup .popup-close-btn');
    
    const options = { 
      dragFree: false,
      loop: true,
      slidesToScroll: 1,
    };
    const emblaApi = EmblaCarousel(viewportNode, options);
  
    emblaApi.on("scroll", throttle(function() {
      const index = emblaApi.selectedScrollSnap();
      const video = emblaApi.slideNodes()[index].querySelector("video");
  
      if (current == video) {
        if (video.paused) video.play();
      } else {
        if (current && !current.paused) {
          current.pause();
        }
        
        video.play();
        current = video;
      }
    }, 1000));
  
    prevButtonNode.addEventListener('click', emblaApi.scrollPrev, false);
    nextButtonNode.addEventListener('click', emblaApi.scrollNext, false);
    
    closeButtonNode.addEventListener('click', function(e) {
      if (current) {
        current.pause();
      };
  
      $(".video-reels__popup").css("display", "none");
      document.body.style.overflow = "auto";
      isShowPopup = false;
    }, false);
  
    popup = emblaApi;
  }

  function setupImageCarousel() {
    $(".product-image-carousel").each((index, el) => {
      const dotNodes = el.closest(".product__wrapper").querySelectorAll(".dot-button");
      
      const emblaApi = EmblaCarousel(el, {
        loop: true,
        slidesToScroll: 1,
      });

      const toggleDotBtnsActive = () => {
        const previous = emblaApi.previousScrollSnap();
        const selected = emblaApi.selectedScrollSnap();
        dotNodes[previous].classList.remove('active');
        dotNodes[selected].classList.add('active');
      }

      $(el).on("mousedown touchstart", function(e) {
        e.stopPropagation();
        e.preventDefault();
      });

      emblaApi.on("select", toggleDotBtnsActive);

      dotNodes.forEach(function(dot, index) {
        dot.addEventListener('click', () => emblaApi.scrollTo(index));
      })
    });
  }

  function checkSharedVideo() {
    const url = new URL(window.location.href);

    const sharedVideoId = url.searchParams.get("video_id");

    if (!sharedVideoId) return;

    const index = $(`[data-id="${sharedVideoId}"]`).data("index");

    if (popup.selectedScrollSnap() != index) {
      popup.scrollTo(index, true);
    }
    
    isShowPopup = true;
    document.body.style.overflow = "hidden";
    $(".video-reels__popup").css("display", "block");
  }

  $(function() {
    setupEvents();

    if (!isSinglePageVideoReels) {
      setupCarousel();
    }
    
    setupPopupCarousel();
    setupImageCarousel();
    checkSharedVideo();
  })
})();